// extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__qsz7O"};